import {postRequest} from '../libs/AxiosService.util';

export async function serviceGetJobReport(params) {
    return await postRequest('reports/jobs', params);
}

export async function serviceDownloadJobExcel(params) {
    return await postRequest('reports/jobs/download', params);
}
